import React from "react";
import styled from "styled-components";

const Styled = styled.div`
  border: dashed 2px #ddd;
  border-radius: 0.5rem;
  padding: 5rem 3rem;
  /* align-items: center; */
  justify-content: center;
  display: flex;

  flex-direction: column;
  gap: 2rem;
`;

const Title = styled.h2`
  font-size: 3rem;
  font-weight: 300;
  color: #333;
`;

const Text = styled.div`
  font-size: 1.3rem;
  color: #777;
`;

const SetupPrompt: React.FC<React.PropsWithChildren<unknown>> & {
  Title: typeof Title;
  Text: typeof Text;
} = (props) => {
  return <Styled>{props.children}</Styled>;
};

SetupPrompt.Title = Title;
SetupPrompt.Text = Text;

export default SetupPrompt;
